import { createFileRoute } from "@tanstack/react-router";
import { apiQuery, useApiSuspenseQuery } from "@/client/lib/api";
import { ensurePage, pageHead } from "@/client/lib/page";
import Loading from "@/client/modules/orcamentos/detalhe/loading";
import { QuoteDetailClient } from "@/client/modules/orcamentos/detalhe/quote-detail-client";

export const Route = createFileRoute("/app/orcamentos/$id")({
  loader: ({ context, params }) =>
    ensurePage(context.queryClient, apiQuery("orcamentos", "detailPage", { id: params.id })),
  head: () => pageHead("Orçamento"),
  pendingComponent: Loading,
  component: OrcamentoDetalhePage,
});

function OrcamentoDetalhePage() {
  const { id } = Route.useParams();
  const { data } = useApiSuspenseQuery("orcamentos", "detailPage", { id });
  return (
    <div className="mx-auto flex max-w-7xl flex-col gap-6">
      <QuoteDetailClient {...data} />
    </div>
  );
}
